import { each } from 'lodash';
import { http } from 'services';

// Images
export function getImages(type, id, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/images`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function getImage(type, id, imageID, cbSuccess, cbError) {
  http.get(
    `${type}/${id}/images/${imageID}`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function removeImages(type, id, data, cbSuccess, cbError) {
  http.delete(
    `${type}/${id}/images`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function updateImages(type, id, data, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/images`,
    data,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function uploadImage(type, id, image, cbSuccess, cbError) {
  const { FormData } = window;
  const form = new FormData();
  form.append('image', image);
  http.post(
    `${type}/${id}/images-upload`,
    form,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function uploadImages(type, id, images, cbSuccess, cbError) {
  const { FormData } = window;
  const form = new FormData();

  each(images, (image) => {
    form.append('image', image);
  });

  http.post(
    `${type}/${id}/images-upload`,
    form,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}
// Images

export function setMainImage(type, id, imageID, cbSuccess, cbError) {
  http.post(
    `${type}/${id}/images/${imageID}/set-main`,
    {},
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}



// WEBPACK FOOTER //
// ./src/api/api-stuff-to-eat/api-stuff-to-eat-images.js